export default __webpack_public_path__ + "static/media/library_my_voice_overs.e9554408.mp3";